module.exports = "<footer class=\"footer\">\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      \r\n    </div>\r\n  </div>\r\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/blocks/footer/footer.component.html
// module id = ./src/app/component/blocks/footer/footer.component.html
// module chunks = main